module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_9.bd05aca1.png";